var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprovedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#86f2ff",
    "data-original": "#746ab9",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86f2ff",
    d: "M511.465 272.355 345.376 106.266 111.324 381.023 241.91 511.609c4.665.253 9.361.391 14.09.391 135.889 0 247.029-105.884 255.465-239.645z",
    "data-original": "#585092",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M228.35 381.023H111.324V162.399l37.191-16.015 18.942-40.118h60.893l31.233 137.379z",
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#edeced"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.35 106.266h117.026v274.757H228.35zM167.457 162.399h-56.133l56.133-56.133z",
    fill: "#f9f3f9",
    "data-original": "#edeced",
    className: "",
    opacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#86f2ff",
    d: "M228.35 192.898h-79.113v-15.369h79.113l13.536 7.685z",
    "data-original": "#746ab9",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86f2ff",
    d: "M228.35 177.529h79.113v15.369H228.35z",
    "data-original": "#585092",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86f2ff",
    d: "M228.35 227.491h-79.113v-15.369h79.113l13.536 7.684z",
    "data-original": "#746ab9",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86f2ff",
    d: "M228.35 212.122h79.113v15.369H228.35z",
    "data-original": "#585092",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86f2ff",
    d: "M228.35 263h-79.113v-15.368h79.113l13.536 7.684z",
    "data-original": "#746ab9",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86f2ff",
    d: "M228.35 247.632h79.113v15.369H228.35z",
    "data-original": "#585092",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86f2ff",
    d: "M228.35 297.593h-79.113v-15.369h79.113l15.239 7.684z",
    "data-original": "#746ab9",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86f2ff",
    d: "M228.35 282.224h23.986v15.369H228.35z",
    "data-original": "#585092",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#77dc5a",
    d: "M345.376 269.604c-7.509 0-15.88-6.014-22.656-3.814-7.022 2.28-10.243 12.142-16.088 16.396-5.904 4.296-16.263 4.341-20.559 10.245-4.254 5.845-1.124 15.69-3.405 22.713-2.2 6.776-10.592 12.867-10.592 20.376s8.392 13.6 10.592 20.376c2.28 7.022-.85 16.867 3.404 22.712 4.296 5.904 14.655 5.949 20.559 10.245 5.845 4.254 9.066 14.116 16.088 16.396 6.776 2.2 15.147-3.813 22.656-3.813L372.7 335.52z",
    "data-original": "#77dc5a",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5bc83e",
    d: "M418.676 335.52c0 7.509-8.392 13.601-10.592 20.376-2.28 7.022.849 16.867-3.405 22.713-4.296 5.904-14.656 5.949-20.559 10.245-5.845 4.254-9.066 14.116-16.088 16.396-6.776 2.2-15.147-3.814-22.656-3.814V269.604c7.509 0 15.881-6.014 22.656-3.813 7.022 2.28 10.243 12.142 16.088 16.396 5.904 4.296 16.263 4.342 20.559 10.245 4.254 5.845 1.124 15.69 3.404 22.712 2.201 6.776 10.593 12.867 10.593 20.376z",
    "data-original": "#5bc83e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5bc83e",
    d: "m370.759 335.52-25.383 50.765c-28.037 0-50.765-22.728-50.765-50.765s22.728-50.765 50.765-50.765z",
    "data-original": "#5bc83e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4eaf36",
    d: "M396.142 335.52c0 28.037-22.728 50.765-50.765 50.765v-101.53c28.036 0 50.765 22.728 50.765 50.765z",
    "data-original": "#4eaf36",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m345.374 341.173-7.268 9.178-20.353-24.289-11.519 9.674 31.872 38.542 7.268-9.133 4.662-17.263z",
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9f3f9",
    d: "M345.374 341.173v23.972l41.358-51.973-11.875-9.233z",
    "data-original": "#edeced",
    className: "",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedIcon);
export default __webpack_public_path__ + "static/media/approvedIcon.eedd41c23701d7be507dc684cc43e48b.svg";
export { ForwardRef as ReactComponent };